// Taşeron portalı — Panel: "Eksikler" (api-contract §28.3 `items` + §28.7 sayfalı/süzülmüş
// hâli). `PendingActionsCard`'ın (S26) yerine geçti — panel rebuild (owner mevcut tasarımı
// beğenmedi, backend §28 AYNEN KALDI, yalnız sunum değişti).
//
// **Kişiye göre gruplama YOK.** Bu kart TÜM kalem türlerini DÜZ bir listede gösterir — bu
// yüzden başlıktaki sayı (`itemsTotal`, temel kümenin GERÇEK boyutu, §28.3) her zaman
// listedeki kalemlerle AYNI kümeden okunur (eski karttaki "sayı ile içerik farklı iki kümeyi
// sayıyor" sorunu, S26 bulgu D3, böylece kendiliğinden çözülüyor).
//
// **Filtre (Tümü/Belge/Eğitim) — moda göre KATMAN değiştirir (§28.7 eklendi).**
// `PermitApproval` yalnız "Tümü"de görünür — ne "Belge" (yalnız `PersonnelDocument`/
// `ContractorDocument`) ne "Eğitim" (yalnız `Training`) onu kapsar; kendi sekmesi yoktur, bu
// bilinçli bir eksiklik değil, dört `kind`'ın üçü zaten iki filtreye net eşleniyor (bkz.
// supplierDashboard.ts §28.7 notu — TAM PARTİSYON, sözleşme dördünü de tanımlar). İstemcinin
// `Filter` literalleri (`all`/`document`/`training`) §28.7'nin `category` değerleriyle BİREBİR
// AYNI dizedir — genişletilmiş modda sunucuya giderken hiçbir eşleme/dönüşüm YAPILMAZ, `filter`
// doğrudan `category` olarak gönderilir.
//
// **Belge türü etiketi `kind`'ın entity'siyle §27 kaydından çözülür (GL #7)** — `SupplierActionItemDto.
// documentType` iki entity'nin kodunu taşıyabilir (`packages/shared/src/api/supplierDashboard.ts`
// dosya başı notu, NORMATİF): `PersonnelDocument` → `personnel`, `ContractorDocument` → `company`.
// Aynı kod iki entity'de bulunabilir (`Insurance`), bu yüzden entity `kind`'dan okunur; kayıtta
// yoksa ham kod. Kayıtta olmayan ya da pasif bir türün eksiği HİÇ karşılanamaz (§27.0(6)): satır
// linksizdir (yükleme yolu sunmaz) ve bunu söyleyen soluk bir satır taşır.
//
// **Training satırının adı UYDURULAMAZ.** `SupplierActionItemDto` hangi eğitimin eksik olduğunu
// TAŞIMAZ — backend yalnız `CompletedTrainingCount < RequiredTrainingCount` toplamından TEK bir
// kalem üretir (`SupplierDashboardService.cs` ~satır 529-532). Satır bu yüzden jenerik okur
// (`dashboard.missing.trainingGeneric`) ve linksizdir — bu portalda kapatılamaz, §28.3
// `blockedBy = 'Personnel'`: yalnız personelin kendisi mobilde (`/supplier/me/trainings`,
// §17.1) kapatır. Sözleşmeye eğitim adı eklenene kadar böyle kalır.
//
// **Daraltılmış (varsayılan) — GÖMÜLÜ `dto.items`, sunucuya EK istek YOK.** Pano yanıtı
// (§28.3) zaten `items`'i taşır (sunucuda sıralı + üst sınırlı, `MaxActionItems`) — kart ilk
// boyamada bunu kullanır: aktif filtreden geçen alt küme İLK `VISIBLE_ROWS` (6) satırla
// sınırlanır; daha fazlası varsa sade bir "Daha fazla göster" satırı (`ArrowRight`, sayısız)
// genişletir. Filtre bu modda İSTEMCİ TARAFINDADIR (`matchesFilter`, gömülü kümeye uygulanır)
// — bir ekstra gidiş-dönüşe DEĞMEZ, çünkü kullanıcı henüz "daha fazla" istemedi.
//
// **Genişletilmiş (`expanded === true`) — SUNUCU sayfalaması + SUNUCU filtresi (§28.7).**
// "Daha fazla göster" tıklanınca kart `GET /supplier/dashboard/items`'e (`useQuery`, yalnız
// `expanded` iken `enabled`) geçer: `category` artık SUNUCUYA gider — istemci `matchesFilter`
// GENİŞLETİLMİŞ modda hiç ÇAĞRILMAZ, dizi zaten süzülmüş gelir. `Pagination` primitifi
// `filteredTotal`'ı SUNUCUDAN alır, istemci türetmesi olan `filtered.length`'ten DEĞİL. Bu,
// önceki turun dürüstlük notunu ("sayfalama YÜKLÜ kümeyi gezer, TÜM kayıtları değil") KÖKTEN
// çözer: sunucu artık gömülü `MaxActionItems` sınırından BAĞIMSIZ, kategoriye göre süzülmüş
// TAM kümeyi sayfalıyor — bu yüzden `dashboard.missing.loadedNote` KALKTI (anahtar üç dilden de
// silindi). Sekme değişimi genişletilmiş moddayken de `page = 1`'e döner (filtre tıklama
// handler'ı, moddan bağımsız).
//
// **Filtre haplarının sayısı iki moda göre AYRIŞIR (dikkat, önceki turun tuzağının devamı):**
// - Daraltılmışken: `dto.items` (gömülü, YÜKLENMİŞ küme) üzerinden `matchesFilter` ile sayılır
//   — "bu düğmeye basarsam KAÇ SATIR göreceğim" sorusuna cevap verir, evrenin gerçek boyutuna
//   DEĞİL (önceki turun notuyla AYNI gerekçe — sunucu kırptıysa hapların toplamı başlıktaki
//   `itemsTotal`'dan düşük kalabilir, bu BİLİNÇLİ ve dürüst).
// - Genişletilmişken: yalnız AKTİF sekmenin hapı sunucudan gelen GERÇEK `filteredTotal`'dır;
//   PASİF sekmelerde hap GÖSTERİLMEZ — ikinci/üçüncü bir istek atmadan pasif sekmenin gerçek
//   sayısı BİLİNMEZ, uydurmak yerine göstermemek tercih edilir (items-pagination-spec.md §13
//   madde 3, R6 azaltımı). "Tümü" hiçbir modda hap taşımaz (başlıktaki `itemsTotal` zaten onun
//   karşılığı).

import type {
  DocumentEntity,
  OpenPersonnelState,
  SupplierActionItemDto,
  SupplierActionItemKind,
  SupplierDashboardDto,
} from '@isgportal/shared';
import {
  Button,
  EmptyState,
  Pagination,
  Skeleton,
  Tooltip,
  cn,
  openPersonnelState,
  supplierDashboardApi,
  useDocumentTypes,
} from '@isgportal/shared';
import { useQuery } from '@tanstack/react-query';
import {
  ArrowRight,
  ChevronRight,
  ClipboardCheck,
  FileText,
  GraduationCap,
  type LucideIcon,
} from 'lucide-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { supplierDashboardKeys } from '../../lib/supplierDashboardKeys';
import { DashboardPanel, PanelHeader } from './PanelHeader';

type TFunction = (key: string, options?: Record<string, unknown>) => string;
/** §27 kayıt etiketi (`useDocumentTypes().label`). */
type TypeLabelFn = (entity: DocumentEntity, code: string) => string;
/** §28.7'nin `category` değerleriyle BİREBİR AYNI dizeler — `permit-approval` hariç (dosya
 * başı notu; bu sekme bilinçli olarak yok). Genişletilmiş modda sunucuya olduğu gibi gönderilir. */
type Filter = 'all' | 'document' | 'training';

const VISIBLE_ROWS = 6;
const PAGE_SIZE = 10;

const KIND_ICON: Record<SupplierActionItemKind, LucideIcon> = {
  PersonnelDocument: FileText,
  ContractorDocument: FileText,
  Training: GraduationCap,
  PermitApproval: ClipboardCheck,
};

function matchesFilter(item: SupplierActionItemDto, filter: Filter): boolean {
  if (filter === 'all') {
    return true;
  }
  if (filter === 'document') {
    return item.kind === 'PersonnelDocument' || item.kind === 'ContractorDocument';
  }
  // filter === 'training' — `PermitApproval` HİÇBİR filtrede eşleşmez dışında "Tümü" (dosya
  // başı notu); burada da eşleşmiyor.
  return item.kind === 'Training';
}

/** Kişi alanı — `ContractorDocument`'ta personel YOKTUR (firma düzeyi belge). */
function personLabel(item: SupplierActionItemDto, t: TFunction): string {
  if (item.kind === 'ContractorDocument') {
    return t('dashboard.missing.companyDocument');
  }
  return item.personnelName ?? '—';
}

/** Belge kalemi türünün entity'si (dosya başı notu, NORMATİF ayrım); belge olmayan kalemde `null`. */
function documentEntity(item: SupplierActionItemDto): DocumentEntity | null {
  if (item.kind === 'ContractorDocument') {
    return 'company';
  }
  return item.kind === 'PersonnelDocument' ? 'personnel' : null;
}

/** Belge türü etiketi — `kind`'ın entity'siyle §27 kaydından (kayıtta yoksa ham kod). */
function documentTypeLabel(item: SupplierActionItemDto, t: TFunction, label: TypeLabelFn): string {
  const entity = documentEntity(item);
  if (!item.documentType || entity === null) {
    return t('dashboard.missing.unknownType');
  }
  return label(entity, item.documentType);
}

/** Belge durumu eki — "eksik" / "süresi geçti" / "reddedildi" / "tarihsiz" (eski `buildChipLabel`
 * ile AYNI türetme, artık chip değil düz metin). */
function documentStatusSuffix(item: SupplierActionItemDto, t: TFunction): string {
  if (item.approvalStatus === 'Rejected') {
    return t('dashboard.missing.status.rejected');
  }
  if (!item.approvalStatus) {
    return t('dashboard.missing.status.missing');
  }
  if (item.validUntil) {
    return t('dashboard.missing.status.expired');
  }
  return t('dashboard.missing.status.noValidity');
}

/** Eksik olan şeyin adı — Training/PermitApproval'da jenerik metin (belge kind'ları satırda ayrı çizilir). */
function missingLabel(item: SupplierActionItemDto, t: TFunction, label: TypeLabelFn): string {
  if (item.kind === 'Training') {
    return t('dashboard.missing.trainingGeneric');
  }
  if (item.kind === 'PermitApproval') {
    return t('dashboard.missing.permitApprovalGeneric');
  }
  // Belge kind'ları satırda `documentTypeLabel` + ayrı durum etiketiyle çizilir; buraya düşmez.
  return documentTypeLabel(item, t, label);
}

/**
 * Link hedefi — yalnız §28.3'ün normatif eşlemesinde gerçek bir hedefi olan kalemler için.
 * Personel belgesi, Personelim listesini o kişinin çekmecesi açık açar (router state, GL5).
 */
function missingTarget(
  item: SupplierActionItemDto,
): { to: string; state?: OpenPersonnelState } | null {
  switch (item.kind) {
    case 'PersonnelDocument':
      return item.personnelUuid
        ? { to: '/personnel', state: openPersonnelState(item.personnelUuid) }
        : null;
    case 'ContractorDocument':
      return { to: '/documents' };
    case 'Training':
      // Bilinçli: bu portalda kapatılamaz (dosya başı notu) — link YOK.
      return null;
    case 'PermitApproval':
      return item.permitUuid ? { to: `/permits/${item.permitUuid}` } : null;
    default:
      return null;
  }
}

/**
 * Satır anahtarı. `linkUuid` TEK BAŞINA benzersiz DEĞİL: backend (`SupplierDashboardService.
 * BuildActionItemsAsync`) kalemi izin × personel × belge türü başına üretir ve `linkUuid` aynı
 * (personel, tür) için bulunan referans belge satırıdır → aynı eksik belge birden çok izinde
 * görünürse aynı `linkUuid` birden çok KALEMDE tekrar eder (meşru satırlar, §28.3 sıralama notu).
 * Satırı ayıran alanlar sıralama zincirinin anahtarlarıdır: kind + personel + izin + tür + link.
 */
function itemKey(item: SupplierActionItemDto): string {
  return [
    item.kind,
    item.personnelUuid ?? '-',
    item.permitUuid ?? '-',
    item.documentType ?? '-',
    item.linkUuid ?? '-',
  ].join(':');
}

export function MissingItemsCard({
  dto,
  companyId,
}: {
  dto: SupplierDashboardDto;
  companyId: number | null;
}) {
  const { t } = useTranslation();
  const { label: typeLabel, inactiveOrUnknown } = useDocumentTypes();
  const [filter, setFilter] = useState<Filter>('all');
  const [expanded, setExpanded] = useState(false);
  const [page, setPage] = useState(1);

  // Daraltılmış modun istemci-tarafı süzgeci — yalnız gömülü `dto.items` üzerinde (dosya başı
  // notu). Genişletilmiş modda KULLANILMAZ (sunucu zaten süzülmüş döner).
  const filtered = dto.items.filter((item) => matchesFilter(item, filter));

  // §28.7 — yalnız GENİŞLETİLMİŞ modda etkin (`enabled: expanded`); daraltılmışken hiçbir
  // istek atılmaz (dosya başı notu). `placeholderData` sayfa/filtre geçişlerinde önceki
  // sonucu ekranda tutar (`PermitsListPage.tsx` ile AYNI desen) — liste VE hap AYNI
  // `itemsQuery.data`'dan okunduğu için geçiş sırasında bile birbirleriyle TUTARLI kalırlar.
  const itemsQuery = useQuery({
    queryKey: supplierDashboardKeys.items(companyId, filter, page, PAGE_SIZE),
    queryFn: () =>
      supplierDashboardApi.listSupplierDashboardItems({
        category: filter,
        page,
        pageSize: PAGE_SIZE,
      }),
    enabled: expanded,
    placeholderData: (prev) => prev,
  });

  const rows = expanded ? (itemsQuery.data?.items ?? []) : filtered.slice(0, VISIBLE_ROWS);
  const showSkeleton = expanded && itemsQuery.isPending;
  const showError = expanded && itemsQuery.isError;
  // Daraltılmışken "Daha fazla göster" — genişletilince yerini sunucu sayfalamasına bırakır.
  const showMore = !expanded && filtered.length > VISIBLE_ROWS;
  // Sayfalama nav'ı yalnız GENİŞLETİLMİŞ, yüklü (ne spinner ne hata) ve birden fazla sayfa
  // varken görünür — toplam SUNUCUDAN (`filteredTotal`), `rows.length`'ten DEĞİL.
  const showPagination =
    expanded && !showSkeleton && !showError && (itemsQuery.data?.filteredTotal ?? 0) > PAGE_SIZE;
  // Alt satır (Daha fazla göster VEYA sayfalama) render ediliyor mu — TEK yerde hesaplanır,
  // hem satır kapsayıcısının `pb-2`'sini KOŞULLAMAK hem alt satırı SEÇMEK için aşağıda AYNI
  // değişken kullanılır (ayrı ayrı türetilirse biri değişip öbürü unutulabilir).
  const hasFooterRow = showMore || showPagination;

  // Karşılanamaz eksik (pasif/kayıtta yok, §27.0(6)): satırın yükleme yoluna link VERİLMEZ ve
  // etiketine kısa "(pasif)" eki girer; açıklama cümlesi listenin altında BİR kez durur.
  const isUnresolvable = (item: (typeof rows)[number]) => {
    const entity = documentEntity(item);
    const code = item.documentType;
    return (
      entity !== null && typeof code === 'string' && code !== '' && inactiveOrUnknown(entity, code)
    );
  };
  const anyUnresolvable = rows.some(isUnresolvable);

  // Filtre haplarının sayısı — moda göre KAYNAK değişir (dosya başı "Filtre haplarının sayısı"
  // notu). Daraltılmışken gömülü `dto.items`'ten `matchesFilter` ile (evrenin gerçek boyutuna
  // DEĞİL, "bu düğmeye basarsam kaç satır göreceğim" sorusuna cevap verir); genişletilmişken
  // YALNIZ aktif sekme için sunucudan (`filteredTotal`) — pasif sekmede `undefined` (hap
  // basılmaz, `f.count !== undefined` kontrolü aşağıda bunu zaten atlar).
  const documentCount = expanded
    ? filter === 'document'
      ? itemsQuery.data?.filteredTotal
      : undefined
    : dto.items.filter((item) => matchesFilter(item, 'document')).length;
  const trainingCount = expanded
    ? filter === 'training'
      ? itemsQuery.data?.filteredTotal
      : undefined
    : dto.items.filter((item) => matchesFilter(item, 'training')).length;

  const filters: { value: Filter; label: string; count?: number }[] = [
    { value: 'all', label: t('dashboard.missing.filter.all'), count: dto.itemsTotal },
    { value: 'document', label: t('dashboard.missing.filter.document'), count: documentCount },
    { value: 'training', label: t('dashboard.missing.filter.training'), count: trainingCount },
  ];

  // Süzgeç grubu — expert `FilterChipGroup` ile aynı desen (aktif rozette dolgu tonu YOK:
  // `bg-primary-foreground/20` mavi üstünde beyaz 11px metni 4.5:1'in altına indirir).
  const filterGroup = (
    <div
      // biome-ignore lint/a11y/useSemanticElements: role="group" kasıtlı — WAI-ARIA "Button Group" deseni (düğmelerden oluşan araç grubu); <fieldset> form denetimleri içindir.
      role="group"
      aria-label={t('dashboard.missing.filter.groupLabel')}
      className="inline-flex items-center gap-1 rounded-md border border-border p-0.5"
    >
      {filters.map((f) => {
        const isActive = filter === f.value;
        return (
          <button
            key={f.value}
            type="button"
            aria-pressed={isActive}
            onClick={() => {
              setFilter(f.value);
              // `expanded` KORUNUR (owner kararı) — kullanıcı genişletmişse filtre
              // değiştirdiğinde kart daralmaz; yalnız sayfa 1'e döner (dosya başı notu).
              setPage(1);
            }}
            // `inline-flex items-center` — etiket + hap AYNI hizada dursun; düğmenin
            // kendisi `min-h-8` başlık satırının İÇİNDE olduğu için bu satırı YÜKSELTMEZ
            // (bkz. yukarıdaki başlık bloğu notu).
            className={cn(
              'inline-flex items-center rounded px-2.5 py-1 text-xs font-medium focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
              isActive
                ? 'bg-primary text-primary-foreground'
                : 'text-muted hover:bg-surface-muted hover:text-fg',
            )}
          >
            {f.label}
            {/* "Tümü" hapı `itemsTotal`ı taşır (expert parity, S37 #12). `count === 0` iken de hap basılır: 0 göstermek hiç
                göstermemekten dürüsttür (kullanıcı boş liste görmeden önce bilir). */}
            {f.count !== undefined ? (
              <span
                className={cn(
                  'ml-1 rounded px-1.5 py-0.5 text-[11px] tnum',
                  isActive
                    ? 'font-semibold text-primary-foreground'
                    : 'bg-surface-muted font-medium text-muted',
                )}
              >
                {f.count}
              </span>
            ) : null}
          </button>
        );
      })}
    </div>
  );

  return (
    <DashboardPanel>
      <PanelHeader icon={FileText} title={t('dashboard.missing.title')} right={filterGroup} />

      {dto.itemsTotal === 0 ? (
        <EmptyState variant="panel" title={t('dashboard.missing.empty')} className="px-4 py-4" />
      ) : showSkeleton ? (
        <div className="flex flex-col gap-3 px-4 py-4" aria-busy="true">
          <output className="sr-only">{t('common.loading')}</output>
          <Skeleton className="h-4" />
          <Skeleton className="h-4" />
          <Skeleton className="h-4" />
        </div>
      ) : showError ? (
        // §28.7 sorgusu başarısız — kart kendi hata satırını basar (ContractorStateNotice
        // burada AŞIRI ağır olurdu, o sayfa düzeyinde kullanılır); genel `state.error.*`
        // anahtarları yeniden kullanılır, yeni anahtar İCAT EDİLMEZ.
        <div className="flex flex-col items-start gap-2 px-4 py-4" role="alert">
          <p className="text-sm text-danger">{t('state.error.body')}</p>
          <Button variant="ghost" size="sm" onClick={() => itemsQuery.refetch()}>
            {t('state.error.retry')}
          </Button>
        </div>
      ) : rows.length === 0 ? (
        // Kalem VAR ama aktif filtre 0 satır veriyor (ör. hiç `Training` yokken "Eğitim"e
        // basmak) — bu, kutlama durumundan (`itemsTotal === 0`) AYRI: ikon YOK, yalnız düz
        // metin. Sessiz boş `div` "yükleniyor mu, bozuk mu?" hissi verirdi (owner bulgusu).
        <EmptyState
          variant="panel"
          title={t('dashboard.missing.filterEmpty')}
          role="status"
          className="px-4 py-4"
        />
      ) : (
        // Alt satır (varsa) satır listesiyle KARDEŞTİR, İÇİNDE DEĞİL — `UpcomingPermitsCard`'ın
        // yapısıyla birebir. İçeri koyulursa `last:border-b-0` listenin son ÇOCUĞUNA (alt satıra)
        // uygulanır, o zaman SON KAYIT satırı kendi `border-b`'sini korur + alt satır kendi
        // `border-t`'sini ekler → üst üste iki 1px çizgi = 2px kalın görünen çift kenarlık
        // (owner bulgusu). Kardeş olunca `last:border-b-0` yeniden SON KAYIT satırına isabet
        // eder ve tek çizgi kalır.
        <>
          <ul className={cn('flex flex-col', !hasFooterRow && 'pb-2')}>
            {rows.map((item) => {
              const Icon = KIND_ICON[item.kind];
              const unresolvable = isUnresolvable(item);
              const target = unresolvable ? null : missingTarget(item);
              const rejectionReason =
                item.approvalStatus === 'Rejected' ? item.rejectionReason : undefined;
              const isDocument =
                item.kind === 'PersonnelDocument' || item.kind === 'ContractorDocument';
              const line1Base = isDocument
                ? `${personLabel(item, t)} — ${documentTypeLabel(item, t, typeLabel)}`
                : `${personLabel(item, t)} — ${missingLabel(item, t, typeLabel)}`;
              const line1 = line1Base;
              const status = isDocument ? documentStatusSuffix(item, t) : null;
              const body = (
                <>
                  <Icon className="h-4 w-4 shrink-0 text-muted" aria-hidden="true" />
                  <div className="min-w-0 flex-1">
                    <div className="flex min-w-0 items-baseline gap-1.5">
                      <p className="min-w-0 truncate text-sm font-medium text-fg" title={line1}>
                        {line1}
                      </p>
                      {unresolvable ? (
                        <span className="shrink-0 text-xs text-muted">
                          {t('documentTypes.inactiveSuffix')}
                        </span>
                      ) : null}
                    </div>
                    {item.permitTitle ? (
                      <p className="truncate text-xs text-muted" title={item.permitTitle}>
                        {item.permitTitle}
                      </p>
                    ) : null}
                  </div>
                  {status ? (
                    <span className="shrink-0 text-xs font-medium text-danger-strong">
                      {status}
                    </span>
                  ) : null}
                </>
              );
              return (
                <li
                  key={itemKey(item)}
                  className="flex items-center border-b border-border last:border-b-0"
                >
                  {target ? (
                    <Link
                      to={target.to}
                      state={target.state}
                      className="flex min-h-14 min-w-0 flex-1 items-center gap-3 px-4 py-2 hover:bg-surface-hover focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-ring"
                    >
                      {body}
                      <ChevronRight className="h-4 w-4 shrink-0 text-muted" aria-hidden="true" />
                    </Link>
                  ) : (
                    <div className="flex min-h-14 min-w-0 flex-1 items-center gap-3 px-4 py-2">
                      {body}
                    </div>
                  )}
                  {rejectionReason ? (
                    <span className="shrink-0 pr-4">
                      <Tooltip
                        label={t('dashboard.missing.rejectionReason.label')}
                        content={rejectionReason}
                      />
                    </span>
                  ) : null}
                </li>
              );
            })}
          </ul>

          {anyUnresolvable ? (
            <p className="border-t border-border px-4 py-2.5 text-xs text-muted">
              {t('documentTypes.inactiveMissing')}
            </p>
          ) : null}

          {hasFooterRow ? (
            showMore ? (
              <button
                type="button"
                onClick={() => setExpanded(true)}
                className="flex w-full items-center gap-1.5 border-t border-border px-4 py-2.5 text-left text-sm font-medium text-primary hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
              >
                {t('dashboard.missing.showMore')}
                <ArrowRight className="h-4 w-4" aria-hidden="true" />
              </button>
            ) : (
              <div className="border-t border-border px-4 py-2.5">
                <Pagination
                  compact
                  page={page}
                  pageSize={PAGE_SIZE}
                  filteredTotal={itemsQuery.data?.filteredTotal ?? 0}
                  onPageChange={setPage}
                  labels={{
                    nav: t('permits.pagination.nav'),
                    previous: t('permits.pagination.previous'),
                    next: t('permits.pagination.next'),
                  }}
                />
              </div>
            )
          ) : null}
        </>
      )}
    </DashboardPanel>
  );
}
